// valueを小数点以下base桁まで表示
const orgRound = (value: number, _base: number): string => {
  return Number(value).toFixed(_base);
};

export default orgRound;
